import FbtListData from "../../components/FBT/FbtListData";
import FbtSubHeader from "../../components/FBT/FbtSubHeader";
import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";

const Fbts = () => {
    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <FbtSubHeader />
                        <FbtListData />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Fbts;